(function() {
  const UPDATE_INTERVAL_MS = 240 * 60 * 1000;
  const STORAGE_KEY = 'homepage_counter_data';
  
  function getCounterData() {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch(e) {
        return null;
      }
    }
    return null;
  }
  
  function saveCounterData(value, timestamp) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      lastUpdate: timestamp,
      value: value
    }));
  }
  
  function formatNumber(num) {
    return Math.floor(num).toLocaleString();
  }
  
  async function fetchLatestCount() {
    try {
      const response = await fetch('/?t=' + Date.now());
      const html = await response.text();
      const match = html.match(/data-countto="(\d+)"/);
      
      if (match && match[1]) {
        const value = parseFloat(match[1]);
        console.log('📡 Fetched fresh total_receipts:', value);
        return value;
      }
    } catch(e) {
      console.error('Failed to fetch latest count:', e);
    }
    return null;
  }
  
  async function runCounter(forceUpdate = false) {
    const el = document.querySelector(".counter");
    if (!el) return;
    
    const targetValue = parseFloat(el.getAttribute("data-countto"));
    const duration = parseInt(el.getAttribute("data-duration"), 100) || 1000;
    const data = getCounterData();
    const now = Date.now();
    
    // Check if the data-countto attribute has changed from stored value
    const storedValue = data ? data.value : null;
    const hasChanged = storedValue !== null && storedValue !== targetValue;
    
    console.log('Counter state:', {
      targetValue,
      storedValue,
      hasChanged,
      forceUpdate
    });
    
    // On page load: check if value changed
    if (!forceUpdate) {
      // If the attribute changed, animate to it
      if (hasChanged) {
        console.log('🔄 Detected change on load - animating from', storedValue, 'to', targetValue);
        
        const startTime = performance.now();
        
        function updateCounter(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const currentValue = storedValue + (targetValue - storedValue) * progress;
          
          el.textContent = formatNumber(currentValue);
          el.style.opacity = '1';
          
          if (progress < 1) {
            requestAnimationFrame(updateCounter);
          } else {
            el.textContent = formatNumber(targetValue);
            saveCounterData(targetValue, now);
            console.log('✅ Counter updated to:', targetValue);
          }
        }
        
        requestAnimationFrame(updateCounter);
      } else {
        // No change - just display current value
        const displayValue = storedValue !== null ? storedValue : targetValue;
        el.textContent = formatNumber(displayValue);
        el.style.opacity = '1';
        saveCounterData(targetValue, now);
        console.log('📊 Page load - displaying:', displayValue);
      }
      return;
    }
    
    // Interval: fetch fresh value and animate
    const fetchedValue = await fetchLatestCount();
    
    if (!fetchedValue) {
      console.log('⚠️ Could not fetch new value');
      return;
    }
    
    const startValue = storedValue !== null ? storedValue : targetValue;
    
    if (fetchedValue === startValue) {
      console.log('⏭️ No change (still ' + startValue + ')');
      return;
    }
    
    console.log('🔄 Interval animating from', startValue, 'to', fetchedValue);
    
    const startTime = performance.now();
    
    function updateCounter(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentValue = startValue + (fetchedValue - startValue) * progress;
      
      el.textContent = formatNumber(currentValue);
      
      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      } else {
        el.textContent = formatNumber(fetchedValue);
        saveCounterData(fetchedValue, now);
        console.log('✅ Counter updated to:', fetchedValue);
      }
    }
    
    requestAnimationFrame(updateCounter);
  }
  
  // Run on page load
  runCounter(false);
  
  // Check every 10 minutes
  setInterval(() => {
    runCounter(true);
  }, UPDATE_INTERVAL_MS);
  
})();
